import React from 'react';
import { LogOut, Volume2, VolumeX, HelpCircle } from 'lucide-react';
import { countdown, fmt } from './wbApi';

/* Barra do topo: respeita a safe area do PWA (hora, Wi-Fi, bateria) pela classe pwa-safe-top. */
/* Saldo de Moedas da Bruxa fica sempre no topo, como num jogo. */
export const WbHud = ({ secondsLeft, secondsToStart, dayIndex, duration, balance, onRecharge, sound, onSound, onExit, onRules }) => (
  <header className="pwa-safe-top sticky top-0 z-40 w-full" data-testid="wb-hud">
    <div className="mx-auto flex w-full max-w-md items-center gap-2 px-3 py-2"
      style={{ background: 'linear-gradient(180deg, rgba(10,6,18,.96), rgba(10,6,18,.75))', backdropFilter: 'blur(10px)' }}>
      <button onClick={onExit} data-testid="wb-exit-btn" aria-label="Sair"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-purple-500/40 bg-black/50 text-purple-200 transition-transform active:scale-90">
        <LogOut className="h-4 w-4 rotate-180" />
      </button>
      <div className="min-w-0 flex-1">
        <h1 className="wb-title truncate text-[17px] leading-none text-orange-400 sm:text-[22px]" style={{ textShadow: '0 0 18px rgba(249,115,22,.6)' }} data-testid="wb-title">
          WITCH'S BALLOON
        </h1>
        <p className="mt-0.5 truncate text-[9px] font-black uppercase tracking-[.12em] text-purple-200/80" data-testid="wb-countdown">
          {secondsToStart > 0 ? `começa em ${countdown(secondsToStart)}`
            : secondsLeft > 0 ? `dia ${dayIndex}/${duration} · ${countdown(secondsLeft)}` : 'evento encerrado'}
        </p>
      </div>
      {balance != null && (
        <button onClick={onRecharge} data-testid="wb-hud-balance" aria-label="Moedas da Bruxa — recarregar"
          className="wb-hud-balance flex h-9 shrink-0 items-center gap-1.5 rounded-full border border-amber-400/60 bg-black/60 pl-1 pr-3 transition-transform active:scale-95">
          <img src="/wb/candy_bruxa.webp" alt="" className="h-7 w-7 object-contain drop-shadow-[0_0_6px_rgba(192,132,252,.8)]" />
          <span className="text-base font-black leading-none text-amber-200" data-testid="wb-hud-balance-value">{fmt(balance)}</span>
          <span className="text-[14px] font-black leading-none text-amber-400">+</span>
        </button>
      )}
      <button onClick={onSound} data-testid="wb-sound-btn" aria-label="Som"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-purple-500/40 bg-black/50 text-purple-200 transition-transform active:scale-90">
        {sound ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
      </button>
      <button onClick={onRules} data-testid="wb-rules-btn" aria-label="Como funciona"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-amber-400/50 bg-black/50 text-amber-300 transition-transform active:scale-90">
        <HelpCircle className="h-4 w-4" />
      </button>
    </div>
  </header>
);
